import React, { useMemo } from 'react'
import useIsMobile from '../../../hooks/use-is-mobile';
import { Separator } from '../../../components/separator';
import { TenancyInCommon } from '../../../models/classes/ApplicationStep3.class';
import MobileTableMobile, { MobileTableItemInterface } from '../../../components/mobile/mobile-table';

interface TenancyInCommonTableProps{
  tenancyData : TenancyInCommon[]
}

function TenancyInCommonTable({...props}:TenancyInCommonTableProps) {

  const { isMobile } = useIsMobile();

  const total_tenancy_share = useMemo(()=>{
    return props.tenancyData.reduce((accum,a)=>{
      let share = a.shares ? a.shares?.toString() : "0";
      return accum + parseInt(share);
    },0);
  },[props.tenancyData])

  const mobile_table_items = useMemo(()=>{
    let obj_items:MobileTableItemInterface[] = props.tenancyData.map(item => {
      return {
        header: item.user.myinfo.name.toString(),
        contents: [item.shares ? `${item.shares}/${total_tenancy_share}` : `0/${total_tenancy_share}`],
        placeholder: ""
      }
    })
    return obj_items;
  },[props.tenancyData, total_tenancy_share])


  return (
    <div className='mt-2'>
      {!isMobile && <div className='ohc-household-structure-table'>
          <div className='ohc-household-structure-table-header'>
            <div className='ohc-household-structure-table-column-2'>
              <p>Owner</p>
            </div>
            <div className='ohc-household-structure-table-column-2'>
              <p>Share</p>
            </div>
          </div>
          <Separator style={{ margin: "16px 0" }} variant={"dashed"}/>
          <div className='ohc-household-structure-table-content'>
            <div className='ohc-household-structure-table-column-2'>
              {
                props.tenancyData.map((owner) => {
                  return <p key={owner.user.myinfo.name}>{owner.user.myinfo.name}</p>;
                })
              }
            </div>

            <div className='ohc-household-structure-table-column-2'>
              {
                props.tenancyData.map((owner) => {
                  return <p key={owner.user.myinfo.name}>{owner.shares}/{total_tenancy_share}</p>;
                })
              }
            </div>

          </div>
        </div>}
        {isMobile && <>
          <MobileTableMobile title='' items={mobile_table_items} variant='full'/>
        </>}
    </div>
  )
}

export default TenancyInCommonTable